import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {annotate, annotationGroup} from 'rough-notation';
import {RoughHeadlineService} from "./rough-headline.service";
import {RoughAnnotation} from "rough-notation/lib/model";
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollTriggerService} from "../../services/scroll-trigger.service";
gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'brt-rough-headline',
  templateUrl: './rough-headline.component.html',
  styleUrls: ['./rough-headline.component.scss']
})

/**
 * This Class uses Rough Notations.
 * Find docs here: https://github.com/rough-stuff/rough-notation
 */
export class RoughHeadlineComponent implements AfterViewInit {

  text = 'Rough Headline';
  isEntered = false;

  @ViewChild('headlineElement') headlineElement: ElementRef = new ElementRef<any>(null);

  /**
   * Use <em> tags to highlight text
   * @param text
   */
  @Input("text") set setText(text: string) {
    this.text = text;
    this.setHeadlineText();
  }

  isInViewport = false;
  groupParts: RoughAnnotation[] = [];

  constructor(private roughHeadlineService: RoughHeadlineService, private scrollTriggerService: ScrollTriggerService) {
  }

  ngAfterViewInit() {
    this.setHeadlineText();

    const st = ScrollTrigger.create({
      trigger: this.headlineElement.nativeElement,
      start: "top bottom-=100",
      once: true,
      onEnter: () => {
        setTimeout(() => {
          const group = annotationGroup([...this.groupParts]);
          group.show();
          this.scrollTriggerService.updateTriggers();
          this.isEntered = true;

        }, 200);
      }
    });

    this.scrollTriggerService.addST(st);
  }

  triggerManually(): void {
    const group = annotationGroup([...this.groupParts]);
    group.show();
    this.scrollTriggerService.updateTriggers();

  }

  setHeadlineText() {
    if(this.headlineElement.nativeElement) {
      this.groupParts = [];
      window.requestAnimationFrame(() => {
        this.headlineElement.nativeElement.innerHTML = this.text;
        this.headlineElement.nativeElement.querySelectorAll("em").forEach((el: any) => {
          const annotation = annotate(el, {
            type: 'highlight',
            multiline: true,
            color: 'rgba(186,207,211,0.5)',
            iterations: 2,
            animate: true,
            animationDuration: 600
          });

          this.roughHeadlineService.addHeadline(annotation);
          this.groupParts.push(annotation);

          if(this.isEntered) {
            this.triggerManually();
          }
        });


        this.scrollTriggerService.updateTriggers();
      });
    }
  }

}
